import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {DialogsModule} from '@progress/kendo-angular-dialog';

import {ApiDocsHelpComponent} from './content/api-docs-help.component';
import {BusinessRulesHelpComponent} from './content/business-rules-help.component';
import {ConfigurationHelpComponent} from './content/configuration-help.component';
import {DashboardHelpComponent} from './content/dashboard-help.component';
import {DefaultHelpComponent} from './content/default-help.component';
import {ForecastHelpComponent} from './content/forecast-help.component';
import {GroupSalesHelpComponent} from './content/group-sales-help.component';
import {InventoryHelpComponent} from './content/inventory-help.component';
import {PortfolioHelpComponent} from './content/portfolio-help.component';
import {RulePrioritiesHelpComponent} from './content/rule-priorities-help.component';
import {StatusHelpComponent} from './content/status-help.component';
import {HelpDialogComponent} from './help-dialog.component';

/* Per-page help. Content components are declared here rather than in their own
   feature modules so the registry can import them without the shared layer
   depending on a feature module. */
@NgModule({
    declarations: [
        HelpDialogComponent,
        DefaultHelpComponent,
        ApiDocsHelpComponent,
        BusinessRulesHelpComponent,
        ConfigurationHelpComponent,
        DashboardHelpComponent,
        ForecastHelpComponent,
        GroupSalesHelpComponent,
        InventoryHelpComponent,
        PortfolioHelpComponent,
        RulePrioritiesHelpComponent,
        StatusHelpComponent
    ],
    imports: [
        CommonModule,
        ButtonsModule,
        DialogsModule
    ],
    exports: [
        HelpDialogComponent
    ]
})
export class HelpDialogModule {
}
